const NUMBER_FORMAT = new Intl.NumberFormat('en-US');

export function formatCount(value: number): string {
  if (!Number.isFinite(value)) return '—';
  return NUMBER_FORMAT.format(Math.round(value));
}

export function formatPercent(value: number, digits = 1): string {
  if (!Number.isFinite(value)) return '—';
  return `${(value * 100).toFixed(digits)}%`;
}

/** Signed count for deltas, using a real minus sign rather than a hyphen. */
export function formatSignedCount(value: number): string {
  const rounded = Math.round(value);
  if (rounded === 0) return 'no change';
  return `${rounded > 0 ? '+' : '−'}${formatCount(Math.abs(rounded))}`;
}

export function formatSignedPercent(value: number, digits = 2): string {
  if (Math.abs(value) < 0.5 / 10 ** (digits + 2)) return 'no change';
  return `${value > 0 ? '+' : '−'}${formatPercent(Math.abs(value), digits)}`;
}

/** Percent as an input value: 0.335 -> 33.5 */
export function rateToInput(rate: number): number {
  return Math.round(rate * 1000) / 10;
}
